import React, { Component } from "react";

class ImageCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = { currentIndex: props.initialIndex || 0 };
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
    if (this.props.isOpen) document.body.classList.add("modal-open");
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.isOpen &&
      (!prevProps.isOpen || prevProps.initialIndex !== this.props.initialIndex)
    ) {
      this.setState({ currentIndex: this.props.initialIndex || 0 });
    }
    if (this.props.isOpen && !prevProps.isOpen) {
      document.body.classList.add("modal-open");
    } else if (!this.props.isOpen && prevProps.isOpen) {
      document.body.classList.remove("modal-open");
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.body.classList.remove("modal-open");
  }

  nextImage = () => {
    const { images } = this.props;
    if (!images || images.length === 0) return;
    this.setState(prev => ({
      currentIndex: (prev.currentIndex + 1) % images.length
    }));
  };

  prevImage = () => {
    const { images } = this.props;
    if (!images || images.length === 0) return;
    this.setState(prev => ({
      currentIndex: prev.currentIndex === 0 ? images.length - 1 : prev.currentIndex - 1
    }));
  };

  handleKeyDown = (e) => {
    if (!this.props.isOpen) return;
    if (e.key === "Escape") this.props.onClose();
    else if (e.key === "ArrowRight") this.nextImage();
    else if (e.key === "ArrowLeft") this.prevImage();
  };

  render() {
    const { images, onClose, isOpen } = this.props;
    const { currentIndex } = this.state;

    if (!isOpen || !images || images.length === 0) return null;
    const image = images[currentIndex] || images[0];
    const multiple = images.length > 1;

    return (
      <div className="carousel-overlay" onClick={onClose}>
        <div className="carousel-container" onClick={(e) => e.stopPropagation()}>
          <button className="carousel-close" onClick={onClose} aria-label="Close">
            ×
          </button>

          <div className="carousel-content">
            {multiple && (
              <button
                className="carousel-nav carousel-prev"
                onClick={this.prevImage}
                aria-label="Previous image"
              >
                ‹
              </button>
            )}

            <div className="carousel-image-container">
              <picture>
                {image.srcWebp && <source srcSet={image.srcWebp} type="image/webp" />}
                <img
                  src={image.src}
                  alt={image.alt || `Image ${currentIndex + 1}`}
                  className="carousel-image"
                  decoding="async"
                />
              </picture>
              {multiple && (
                <div className="carousel-counter">
                  {currentIndex + 1} / {images.length}
                </div>
              )}
            </div>

            {multiple && (
              <button
                className="carousel-nav carousel-next"
                onClick={this.nextImage}
                aria-label="Next image"
              >
                ›
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default ImageCarousel;
